import * as React from 'react';
import { preloadImagesFromResponse } from './preloadImagesFromResponse';
import { presetInitialAnswersState } from '../../FormContainer';
import { TFormStoreData } from '../../../types/form';
import { TFormContext } from '../../FormContainer/types/internal';

export const useOnRenderedInBrowser = (formData: TFormStoreData, formContext: TFormContext) => {
  React.useEffect(() => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      preloadImagesFromResponse(formData);
      presetInitialAnswersState(formContext, formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
